import { render, staticRenderFns } from "./DccFollowUp.vue?vue&type=template&id=45fb2e70&"
import script from "./DccFollowUp.vue?vue&type=script&lang=js&"
export * from "./DccFollowUp.vue?vue&type=script&lang=js&"
import style0 from "./DccFollowUp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports